export const TO_BE_NOMINATED = "TBA"; // "to be nominated" - convention, if value is unknown for actual moment

export const MOBILE_BREAKPOINT = 780;

export const TABLET_BREAKPOINT = 781;

export const CARDS_REQUEST_LIMIT = 5;

export const APP_CONTAINER_NODE_CLASSNAME = "app-container-total-tracking";

export const APP_ROOT_NODE_CLASSNAME = "app-root-total-tracking";

export const POPUP_NODE_CLASSNAME = "app-modal-total-tracking";

export const DEFAULT_LANG = "en";

export const IS_APP_IN_IFRAME = window.self !== window.top;
